// extracted by mini-css-extract-plugin
export default {"button":"ButtonSmall_button__N3rkF"};